import React from 'react';

const base = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.4,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export const IconMenu = (p) => (
  <svg viewBox="0 0 24 24" {...base} {...p}>
    <path d="M3 6h18M3 12h18M3 18h18" />
  </svg>
);

export const IconClose = (p) => (
  <svg viewBox="0 0 24 24" {...base} {...p}>
    <path d="M18 6 6 18M6 6l12 12" />
  </svg>
);

export const IconArrowRight = (p) => (
  <svg viewBox="0 0 24 24" {...base} {...p}>
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
);

export const IconArrowLeft = (p) => (
  <svg viewBox="0 0 24 24" {...base} {...p}>
    <path d="M19 12H5M11 18l-6-6 6-6" />
  </svg>
);

export const IconPhone = (p) => (
  <svg viewBox="0 0 24 24" {...base} {...p}>
    <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.2a2 2 0 0 1 2.1-.5c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2Z" />
  </svg>
);

export const IconMail = (p) => (
  <svg viewBox="0 0 24 24" {...base} {...p}>
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="m2 7 10 6 10-6" />
  </svg>
);

export const IconPin = (p) => (
  <svg viewBox="0 0 24 24" {...base} {...p}>
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

export const IconClock = (p) => (
  <svg viewBox="0 0 24 24" {...base} {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3.5 2" />
  </svg>
);

export const IconInstagram = (p) => (
  <svg viewBox="0 0 24 24" {...base} {...p}>
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.4" cy="6.6" r="1" fill="currentColor" stroke="none" />
  </svg>
);

export const IconFacebook = (p) => (
  <svg viewBox="0 0 24 24" {...base} {...p}>
    <path d="M15 3h-2.5A4.5 4.5 0 0 0 8 7.5V10H5.5v4H8v8h4v-8h3l1-4h-4V7.5A.5.5 0 0 1 12.5 7H15V3Z" />
  </svg>
);

export const IconWhatsApp = ({ solid = false, ...p }) => (
  <svg viewBox="0 0 24 24" {...(solid ? { fill: 'currentColor', stroke: 'none' } : base)} {...p}>
    {solid ? (
      <path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2Zm5.6 14.1c-.2.7-1.4 1.3-2 1.4-.5.1-1.1.1-1.8-.1a14 14 0 0 1-6.2-5.4c-.5-.7-.9-1.6-.9-2.5s.5-1.4.7-1.6c.2-.2.4-.3.6-.3h.5c.2 0 .4 0 .6.5l.8 1.9c0 .2 0 .3-.1.5l-.3.4-.3.3c-.1.1-.2.3-.1.5a8 8 0 0 0 3.8 3.3c.2.1.4.1.5 0l.7-.8c.2-.2.3-.2.5-.1l1.8.9c.2.1.4.2.4.3.1.2.1.6-.1 1.3Z" />
    ) : (
      <>
        <path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2Z" />
        <path d="M8.4 8.2c.2-.2.4-.3.6-.3h.5c.2 0 .4 0 .6.5l.8 1.9c0 .2 0 .3-.1.5l-.6.7c-.1.1-.2.3-.1.5a8 8 0 0 0 3.8 3.3c.2.1.4.1.5 0l.7-.8c.2-.2.3-.2.5-.1l1.8.9c.2.1.4.2.4.3.1.2.1.6-.1 1.3-.2.7-1.4 1.3-2 1.4-.5.1-1.1.1-1.8-.1a14 14 0 0 1-6.2-5.4c-.5-.7-.9-1.6-.9-2.5s.5-1.4.7-1.6Z" />
      </>
    )}
  </svg>
);

export const IconPlay = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
    <path d="M8 5.5v13a1 1 0 0 0 1.5.9l11-6.5a1 1 0 0 0 0-1.7l-11-6.5A1 1 0 0 0 8 5.5Z" />
  </svg>
);

export const IconSparkle = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
    <path d="M12 2.5 13.6 9 20 10.6 13.6 12.2 12 18.7 10.4 12.2 4 10.6 10.4 9 12 2.5ZM19 16l.7 2.6 2.6.7-2.6.7-.7 2.6-.7-2.6-2.6-.7 2.6-.7L19 16Z" />
  </svg>
);

export const IconCheck = (p) => (
  <svg viewBox="0 0 24 24" {...base} {...p}>
    <path d="m4 12.5 5 5L20 6.5" />
  </svg>
);

export const IconPlus = (p) => (
  <svg viewBox="0 0 24 24" {...base} {...p}>
    <path d="M12 5v14M5 12h14" />
  </svg>
);

export const IconZoom = (p) => (
  <svg viewBox="0 0 24 24" {...base} {...p}>
    <circle cx="11" cy="11" r="7" />
    <path d="M20 20l-3.2-3.2M11 8.5v5M8.5 11h5" />
  </svg>
);

/** The lotus + peacock mark, redrawn as an inline ornament. */
export const Lotus = ({ className = '' }) => (
  <svg viewBox="0 0 64 40" className={className} fill="currentColor" aria-hidden="true">
    <path d="M32 4c1.9 2.6 2.9 5.6 2.9 8.9 0 3.6-1 6.6-2.9 9-1.9-2.4-2.9-5.4-2.9-9 0-3.3 1-6.3 2.9-8.9Z" opacity=".95" />
    <path d="M32 8.6c2.3 0 4.2 2.3 4.2 6.3 0 5.2-1.6 9.9-4.2 14.3-2.6-4.4-4.2-9.1-4.2-14.3 0-4 1.9-6.3 4.2-6.3Z" opacity=".35" />
    <path d="M20.6 11.4c3 .5 5.5 2 7.4 4.4 2 2.6 2.9 5.5 2.8 8.8-3-.6-5.5-2.1-7.4-4.5-1.9-2.5-2.9-5.4-2.8-8.7ZM43.4 11.4c.1 3.3-.9 6.2-2.8 8.7-1.9 2.4-4.4 3.9-7.4 4.5-.1-3.3.8-6.2 2.8-8.8 1.9-2.4 4.4-3.9 7.4-4.4Z" />
    <path d="M10 17.6c3.4-.4 6.5.3 9.2 2.2 2.8 1.9 4.6 4.5 5.4 7.7-3.4.5-6.5-.2-9.3-2.1-2.7-1.9-4.5-4.5-5.3-7.8ZM54 17.6c-.8 3.3-2.6 5.9-5.3 7.8-2.8 1.9-5.9 2.6-9.3 2.1.8-3.2 2.6-5.8 5.4-7.7 2.7-1.9 5.8-2.6 9.2-2.2Z" />
    <path d="M32 22.4c3.6 0 6.2 2.6 6.2 6.1 0 2.5-1 4.6-2.9 6.2h-6.6c-1.9-1.6-2.9-3.7-2.9-6.2 0-3.5 2.6-6.1 6.2-6.1Z" opacity=".9" />
  </svg>
);
